import { Injectable } from '@angular/core';
import { I18nRestService } from 'app/core/services/rest/i18n.rest.service';
import { appSettings } from 'app/appSettings';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class I18Sandbox {
  private referenceJson = new BehaviorSubject<object>(null);
  private json = new BehaviorSubject<{ language: string; json: object }>(null);

  constructor(private i18nRestService: I18nRestService) {
  }

  referenceJson$(): Observable<object> {
    if (!this.referenceJson.getValue()) {
      this.referenceJson.next({});
      this.i18nRestService.getCheckedInTranslations(appSettings.DEFAULT_LANGUAGE).subscribe(json => {
        this.referenceJson.next(json);
      });
    }
    return this.referenceJson.asObservable().pipe(filter(v => Object.keys(v).length > 0));
  }

  json$(language: string): Observable<object> {
    if (!this.json.getValue() || this.json.getValue().language !== language) {
      this.json.next({ language, json: {} });
      this.i18nRestService.getServerTranslations(language).subscribe(json => {
        this.json.next({ language, json });
      });
    }
    return this.json.asObservable().pipe(map(v => v.json), filter(v => Object.keys(v).length > 0));
  }
}
